import { convertLocale } from '@pe-libs/react-components/build/lib/helper';
import { NextPage } from 'next';
import React from 'react';
import { getQueryParameters } from '#helpers/query';
import { setUserIntl } from '#modules/app/actions/settings';
import { profilePublicDetailsRequested } from '#modules/defaultLandingReferral/actions';
import { getParameters } from '#modules/defaultLandingReferral/components/DefaultSurveyThankYouPage/helper';
import Landing from '#modules/defaultLandingReferral/components/Landing';
import { wrapper } from '../store';
import { StateType } from '../types';

type PropsType = {
  state: StateType;
  props: {
    data: {
      attributes: {
        id: string;
        title: string;
        description: string;
        offers: string;
        profileUrl: string;
        avatarUrlFull: string;
        avatarUrlMedium: string;
        headerUrlFull: string;
        headerUrlMedium: string;
      };
    };
  };
};

export const DefaultReferralLanding: NextPage<PropsType> = ({ props }) => <Landing data={props.data} />;

DefaultReferralLanding.getInitialProps = wrapper.getInitialPageProps((store) => async (context) => {
  const lang = getQueryParameters(context.query, 'lang');
  const locale = convertLocale(lang, 'locale');
  const { profile, profileId } = getParameters(context.query);

  store.dispatch(setUserIntl({ locale }));
  const result = await store.dispatch(profilePublicDetailsRequested({ profileId: profile || profileId }));

  return { props: { data: (result.payload as PropsType['props'])?.data } };
});

export default DefaultReferralLanding;
